import React from "react";
import { motion } from "framer-motion";
import { FaHospital, FaLeaf, FaHandshake, FaStar } from "react-icons/fa";
import { Footer } from "../../components";

const PartnersPage: React.FC = () => {
  const partners = [
    {
      name: "Pharmacie Sainte-Marie",
      category: "Pharmacie",
      logo: "https://cdn-icons-png.flaticon.com/512/2966/2966327.png",
    },
    {
      name: "MediWell Nature",
      category: "MediWell",
      logo: "https://cdn-icons-png.flaticon.com/512/2975/2975175.png",
    },
    {
      name: "PharmaCité",
      category: "Pharmacie",
      logo: "https://cdn-icons-png.flaticon.com/512/2966/2966397.png",
    },
    {
      name: "ZenBio",
      category: "MediWell",
      logo: "https://cdn-icons-png.flaticon.com/512/2975/2975173.png",
    },
  ];

  return (
    <div className="bg-green-900 min-h-screen flex flex-col text-white">
      {/* Header Section */}
      <section className="relative py-16 px-6 text-center overflow-hidden">
        <motion.div
          initial={{ opacity: 0, y: -30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="relative z-10"
        >
          <h1 className="text-4xl md:text-6xl font-extrabold text-yellow-400 mb-4">
            Nos Partenaires
          </h1>
          <p className="max-w-3xl mx-auto text-gray-200 text-lg leading-relaxed">
            Découvrez les <strong>pharmacies</strong> et{" "}
            <strong>partenaires MediWell</strong> qui font vivre l’écosystème
            <span className="text-green-400 font-semibold"> Mediiq</span> 🌿
          </p>
        </motion.div>

        <div className="absolute inset-0 bg-gradient-to-b from-black/50 to-green-900/90 z-0" />
      </section>

      {/* Categories */}
      <div className="flex justify-center flex-wrap gap-4 mb-10">
        {[
            // @ts-ignore
          { icon: <FaHospital />, label: "Pharmacies partenaires", color: "bg-green-700" },
           // @ts-ignore
          { icon: <FaLeaf />, label: "MediWell créateurs", color: "bg-yellow-500" },
           // @ts-ignore
          { icon: <FaStar />, label: "Partenaires Premium", color: "bg-blue-600" },
        ].map((item, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: i * 0.2 }}
            className={`flex items-center gap-3 px-6 py-3 rounded-full text-white font-semibold shadow-lg ${item.color}`}
          >
            {item.icon} <span>{item.label}</span>
          </motion.div>
        ))}
      </div>

      {/* Partners Grid */}
      <section className="flex-grow px-6 md:px-16 pb-16">
        <div className="grid sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {partners.map((partner, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.1 }}
              className="bg-white text-green-900 rounded-2xl shadow-xl p-6 flex flex-col items-center hover:scale-105 transition-transform"
            >
              <img
                src={partner.logo}
                alt={partner.name}
                className="w-20 h-20 mb-4 rounded-full object-contain"
              />
              <h3 className="font-bold text-lg text-center">{partner.name}</h3>
              <p className="text-sm text-green-700 italic">{partner.category}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* Become Partner CTA */}
      <motion.section
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="bg-yellow-400 text-green-900 text-center py-12 px-6"
      >
        <h2 className="text-3xl font-extrabold mb-4">💼 Devenez partenaire Mediiq</h2>
        <p className="max-w-2xl mx-auto mb-6 text-lg">
          Rejoignez un réseau dynamique de pharmacies et de créateurs de bien-être,
          et profitez des avantages exclusifs de l’écosystème <strong>Mediiq</strong>.
        </p>
        <a
          href="https://partners.mediiq.app"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-3 bg-green-900 text-yellow-400 font-bold rounded-full shadow-lg hover:bg-green-800 transition transform hover:scale-105"
        >
          🌟 Devenir partenaire
        </a>
      </motion.section>

      <Footer />
    </div>
  );
};

export default PartnersPage;